export default __webpack_public_path__ + "static/media/icon.night vision optics.9a512660.svg";